/* eslint-disable consistent-return */
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),

    handleFileUpload(e, acceptedFile, maxSize) {
      return new Promise((resolve) => {
        const file = e.target.files;
        const isAcceptedType = acceptedFile.includes(file[0].type);
        const fileSize = Math.round(file[0].size / 1024 / 1024);

        if (!isAcceptedType) this.toggleProblem('Please choose a wanted file!');
        if (fileSize > maxSize) this.toggleProblem('Please upload file with maximum size 5MB!');
        if (isAcceptedType && fileSize <= maxSize) {
          this.uploadFile(file).then((res) => {
            resolve(res);
          });
        }
      });
    },

    uploadFile(file) {
      return new Promise((resolve) => {
        let imageData = null;
        let fileName = null;

        this.showLoading();
        if (file) {
          this.getBase64(file[0]).then((data) => {
            const commaPosition = data.lastIndexOf(',') + 1;
            imageData = data.substring(commaPosition);
            fileName = file[0].name;

            const sendData = {
              filename: fileName,
              content: imageData,
            };

            axios.post(`${process.env.GATE_URL}//file`, sendData, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: (JSON.parse(localStorage.getItem('Token'))).value,
              },
            }).then((res) => {
              const imageUrl = res.data.data.url;
              this.hideLoading();
              resolve(imageUrl);
            }).catch((error) => {
              this.hideLoading();
              this.toggleProblem(error.response.data.message);
            });
          });
        }
      });
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/jMixUploadFile.js